import { FileSpreadsheet, IdCardLanyard, ShieldCheck, UserRound } from "lucide-react";

const mfaAdNavigation = [
  {
    key: "/pam/directory",
    icon: <IdCardLanyard className="icon" />,
    label: "Identity Sources",
    navigate: "/pam/directory",
  },
  {
    key: "/pam/users",
    icon: <UserRound className="icon" />,
    label: "Users",
    navigate: "/pam/users",
  },
  {
    key: "/pam/policies/ad",
    icon: <FileSpreadsheet className="icon" />,
    label: "Policies",
    navigate: "/pam/policies/ad",
  },
  // Old policy logs page — hidden from the AD sidebar (still reachable via /pam/policy-logs URL).
  // {
  //   key: "/pam/policy-logs",
  //   icon: <ScrollText className="icon" />,
  //   label: "Logs(old)",
  //   navigate: "/pam/policy-logs",
  // },
  {
    key: "/pam/auth-logs",
    icon: <ShieldCheck className="icon" />,
    label: "Logs",
    navigate: "/pam/auth-logs",
  },
];

export default mfaAdNavigation;
